import { render, staticRenderFns } from "./DeltaDialog.vue?vue&type=template&id=3756ed20&scoped=true&"
import script from "./DeltaDialog.vue?vue&type=script&lang=js&"
export * from "./DeltaDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeltaDialog.vue?vue&type=style&index=0&id=3756ed20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3756ed20",
  null
  
)

export default component.exports
import {QDialog,QToolbar,QToolbarTitle,QBtn} from 'quasar'
component.options.components = Object.assign({QDialog,QToolbar,QToolbarTitle,QBtn}, component.options.components || {})
